import * as React from 'react';
import { Alert } from '@grandvisionhq/iris-ui';

const NoStoresAlert = ({ labels , onClearAppointmentType  })=>/*#__PURE__*/ React.createElement(Alert, {
        className: "alert-m-default no-stores-alert",
        variant: "warning"
    }, /*#__PURE__*/ React.createElement("div", null, `${labels.message} `, /*#__PURE__*/ React.createElement("button", {
        className: "no-stores-alert__button",
        onClick: onClearAppointmentType
    }, labels.action), "."))
;

export { NoStoresAlert as default };
//# sourceMappingURL=NoStoresAlert.js.map
